import { render, staticRenderFns } from "./UpsertResourceModal.vue?vue&type=template&id=3c352ad1&"
import script from "./UpsertResourceModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertResourceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports